<template>
  <div>
    <div id="loader" style="display:none;position:fixed; top: 0; left: 0; background-color: black; opacity: 0.3; width: 100%; height: 100%; z-index: 99999999">
      <img src="@/assets/images/loader_img.gif" style="top: 45%; left: 40%; position: absolute;" />
    </div>
    <mainMenu v-if="isLoggedIn"></mainMenu>
    <main class="admin">
        <transition name="leave">
          <router-view></router-view>
        </transition>
    </main>
    <maskBg v-if="getPopupCart || getPopupWishList" @click.native="showPopupCart()"/>
    <transition name="appear">
      <popupcart class="cart" v-if="getPopupCart"/>
    </transition>
    <transition name="appear">
      <popupwishlist class="cart" v-if="getPopupWishList"/>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import mainMenu from './components/Menu';
import popupcart from './components/Popupcart';
import popupwishlist from './components/PopupWishlist';
import maskBg from './components/Mask';

export default {
  components: {
    mainMenu,
    popupcart,
    popupwishlist,
    maskBg
  },
  methods: {
    ...mapActions([
      'showOrHiddenPopupCart',
      'showOrHiddenPopupWishlist',
    ]),
    hasProduct() {
      return this.getProductsInCart != null && this.getProductsInCart.length > 0;
    },
    showPopupCart() {
      if (this.getPopupCart)
        this.showOrHiddenPopupCart();

      if (this.getPopupWishList)
        this.showOrHiddenPopupWishlist();
    }
  },
  mounted(){

  },
  computed: {
    ...mapGetters([
      'getProductsInCart',
      'getPopupCart',
      'getProductsInWishlist',
      'getPopupWishList',
    ]),
    total: function(){
      if (this.getProductsInCart != null)
      {
        let total = [];
        Object.entries(this.getProductsInCart).forEach(([key, val]) => {
            total.push(val.ammount)
        });
        return total.reduce(function(total, num){ return total + num }, 0);
      }
      else
      {
        return 0;
      }
    },
    totalWishlist: function(){
      if (this.getProductsInWishlist != null)
      {
        let total = [];
        Object.entries(this.getProductsInWishlist).forEach(([key, val]) => {
            total.push(1)
        });
        return total.reduce(function(total, num){ return total + num }, 0);
      }
      else
      {
        return 0;
      }
    }
  },
};
</script>


<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.vue-notification {
  padding: 10px;
  margin: 0 5px 5px;
 
  font-size: 12px;
 
  color: #ffffff;
  background: #44A4FC;
  border-left: 5px solid #187FE7;
 
  &.error-notification {
    background: #E54D42;
    border-left-color: #B82E24;
  }
 
  &.success-notification {
    background: #68CD86;
    border-left-color: #42A85F;
  }
}
</style>
